<template>
  <div>
    <Head title="Create Customer" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/customers">Customers</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Create Customer</li>
      </ol>
    </nav>
    <h1>Create Customer</h1>

    <div class="content-box">
      <form @submit.prevent="store">
        <CustomerForm :form="form" />

        <div class="actions-toolbar">
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Create Customer</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import CustomerForm from './components/CustomerForm'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    CustomerForm,
    LoadingButton
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        company: null,
        title: null,
        first_name: null,
        middle_name: null,
        last_name: null,
        address_1: null,
        address_2: null,
        postal_code: null,
        city: null,
        country: null,
        state: null,
        email: null,
        website: null,
        phone: null,
        cell_phone: null,
        passengers: [],
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/customers')
    }
  },
}
</script>

<style lang="scss">
.passenger-item {
  padding: 1rem;
  margin-bottom: 1rem;
  background: $gray-200;
}
</style>
